/* eslint-disable @typescript-eslint/no-var-requires */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import t from "./index";

const { getResources, languages, namespaces } = t;

const initI18n = async () => {
    const resources = await getResources();

    await i18n
        // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
        // learn more: https://github.com/i18next/i18next-http-backend
        .use(Backend)
        // detect user language
        // learn more: https://github.com/i18next/i18next-browser-languageDetector
        .use(LanguageDetector)
        // pass the i18n instance to react-i18next.
        .use(initReactI18next)
        // init i18next
        // for all options read: https://www.i18next.com/overview/configuration-options
        .init({
            resources,
            ns: namespaces,
            fallbackLng: "en",
            debug: false,
            whitelist: languages,

            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            },
            react: {
                useSuspense: true, // set to true when using suspense for lazy loading in the application
            },
        });
};

initI18n().catch(() => undefined);

export default i18n;
